import { render, staticRenderFns } from "./DirectoryBrowser.vue?vue&type=template&id=2b94356e&scoped=true&"
import script from "./DirectoryBrowser.vue?vue&type=script&lang=js&"
export * from "./DirectoryBrowser.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryBrowser.vue?vue&type=style&index=0&id=2b94356e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94356e",
  null
  
)

export default component.exports